/**
 * @file: Horn.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 喇叭配置管理
 */
import request from '@/utils/request'

/**
 * 喇叭配置新增
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function hornAdd(data) {
  return request({
    type: 'device',
    url: 'horn/add',
    method: 'post',
    data
  })
}

/**
 * 喇叭配置删除
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function hornDelete(data) {
  return request({
    type: 'device',
    url: 'horn/delete',
    method: 'post',
    data
  })
}

/**
 * 喇叭配置查询
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function hornGet(data) {
  return request({
    type: 'device',
    url: 'horn/get',
    method: 'post',
    data
  })
}

/**
 * 喇叭配置信息列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function hornListGet(data) {
  return request({
    type: 'device',
    url: 'horn/list/get',
    method: 'post',
    data
  })
}

/**
 * 喇叭配置编辑
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function hornUpdate(data) {
  return request({
    type: 'device',
    url: 'horn/update',
    method: 'post',
    data
  })
}

/**
 * 报警设备-喇叭配置信息列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function hornWarnListGet(data) {
  return request({
    type: 'device',
    url: 'horn/warn/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Horn.js